import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import sendgridApi from 'src/api/communityApi';
import { SenderInterface } from "../../store/sendgrid/sendersSlice";

const PREFIX = 'sendgrid';

const processStrategy = (value: any) => {
  return { ...value };
}

export const sendersEntity = new schema.Entity(
  'senders',
  {},
  {
    processStrategy
  }
);

export const senderEntity = new schema.Entity(
  'sender',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      sender: SenderInterface;
    }
  >(response.data.sender, senderEntity);
  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized  = normalize<
    any,
    {
      senders: { [key: string]: SenderInterface },
    }
    >(response.data.senders, [sendersEntity]);

  return {
    senders: normalized.entities?.senders || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchSenders = createAsyncThunk(
  `${PREFIX}_senders/fetchSenders`,
  async (params: object = {}) => {
    const response = await sendgridApi.get(`/onesky/sendgrid/senders`, { params })
    return normalizeCollection(response);
  }
);

export const fetchSender = createAsyncThunk(
  `${PREFIX}_senders/fetchSender`,
  async (id: number | string) => {
    const response = await sendgridApi.get(`/onesky/sendgrid/senders/${id}`);
    return normalizeInstance(response);
  }
);
